import { Heart, ShieldCheck } from "lucide-react";

/**
 * NonprofitBadge — small verified-nonprofit indicator.
 *
 * Renders NOTHING when the user (or vendor / event owner passed in via
 * `user` prop) doesn't have `nonprofit_status === "verified"`. Kept small
 * enough to sit inline next to a name/business title without wrapping.
 *
 * Props:
 *   user   -> the object whose nonprofit status we're checking (falls back
 *             to reading `.nonprofit_status` on the passed object)
 *   size   -> "sm" | "md" (default sm — for card grids)
 *   label  -> override the default "Verified Nonprofit" text
 */
export default function NonprofitBadge({ user, size = "sm", label }) {
  if (!user || user.nonprofit_status !== "verified") return null;
  const isSm = size === "sm";
  return (
    <span
      data-testid="nonprofit-badge"
      title={
        user.nonprofit_org_name
          ? `Verified 501(c)(3): ${user.nonprofit_org_name}`
          : "Verified 501(c)(3) nonprofit"
      }
      className={`inline-flex items-center gap-1 rounded-full whitespace-nowrap ${
        isSm ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"
      }`}
      style={{
        backgroundColor: "rgba(132, 204, 22, 0.14)",
        color: "#4B7A0A",
        border: "1.5px solid #84CC16",
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        fontWeight: 700,
      }}
    >
      <Heart className={isSm ? "h-2.5 w-2.5" : "h-3 w-3"} fill="#84CC16" strokeWidth={0} />
      {label || "Verified Nonprofit"}
      <ShieldCheck className={isSm ? "h-2.5 w-2.5" : "h-3 w-3"} />
    </span>
  );
}
